/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC, ReactNode, useCallback, useState } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface TooltipProps {
  message: string;
  children: ReactNode;
  id: string;
  className?: string;
}

export const Tooltip: FC<TooltipProps> = ({ id, message, children, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

  const toggleTooltip = useCallback(() => {
    if (isTouchDevice) {
      setIsVisible((prev) => !prev);
    }
  }, [isTouchDevice]);

  return (
    <span
      data-test-id={id}
      id={id}
      className={mergeClasses('tooltip', className)}
      data-tooltip={message}
      onClick={toggleTooltip}
      data-visible={isVisible ? 'true' : 'false'}
    >
      {children}
    </span>
  );
};
